import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import * as Sentry from '@sentry/react';
import { HelmetProvider } from 'react-helmet-async';

// Initialize Sentry with specific DSN from Sentry dashboard
Sentry.init({
  dsn: "https://208b45f5896eaa3a4ef0c5e5deceddc1@o4509273125224448.ingest.de.sentry.io/4509273135972432",
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set tracePropagationTargets to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // Sample rate for all sessions (10%)
  replaysOnErrorSampleRate: 1.0, // Sample rate for sessions with errors (100%)
  environment: import.meta.env.MODE,
});

// Prerendered public pages are served as static HTML for crawlers and fast first paint,
// then the client app mounts with createRoot (not hydrateRoot) to avoid hydration
// mismatches between the slim prerender tree and the full App provider stack.
createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
